<script lang="ts">
	import AnchorHighlights from './AnchorHighlights.svelte';
	import DirectionallyAwareNav from './DirectionallyAwareNav.svelte';
</script>

<h3>Directionally Aware Nav (from Kevin Powell)</h3>
<DirectionallyAwareNav />

<hr />

<AnchorHighlights />

<style>
	hr {
		width: 100dvw;
		margin-block: 2rem;
	}
</style>
